import React from 'react';

import Modal from 'components/Modal';
import GrowTransition from 'components/Modal/animations/grow';

import { IUseToggle } from '@common/helpers/useToggle';

interface IProps {
	controls?: IUseToggle;
}

function VideoPlayerModal({ controls }: IProps) {
	const { params } = controls;

	return (
		<Modal
			open={controls.isOpen}
			onClose={controls.onClose}
			PaperProps={{
				sx: {
					maxWidth: '800px',
				},
			}}
			title={(params?.title as string) || ''}
			TransitionComponent={GrowTransition}
			transitionDuration={500}
		>
			<video
				width="100%"
				height="100%"
				controls
				autoPlay
				style={{
					objectFit: 'cover',
					width: '100%',
					height: '100%',
					borderRadius: 8,
				}}
			>
				<source src={params.videoUrl as string} type="video/mp4" />
				<track kind="captions" src="" label="No captions" />
			</video>
		</Modal>
	);
}

export default VideoPlayerModal;
